import React from 'react'
import update from 'immutability-helper';

import { user } from '../../../core/controllers/user';
import { notifications } from '../../../core/controllers/Notifications'
import { modal } from '../../../core/utilities/modal';

export default class TransferFees extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            transferFee: false
        }
    }

    componentDidMount() {
        var self = this;

        jQuery(".toggle-switch").bootstrapToggle();
        // TODO figure out why onChange reactjs event does not trigger
        jQuery(".toggle-switch").change(function(e){
            const value = jQuery(e.target).prop('checked');
            const id = jQuery(e.target).attr('notification-type-id');
            if(id !== undefined) {
                notifications.updateSetting(id, value);
            }
        });

        notifications.getUserSettings(function(settings){
            var newState = {};
            const data = settings.data;
            // TODO implement better mapping ability
            for(var i = 0; i < data.length; i++) {
                if(data[i].alias == 'transfer-fee') {
                    if(data[i].value == 1) {
                        newState['transferFee'] = true;
                        jQuery('#transferFee').bootstrapToggle('on');
                    }
                    jQuery('#transferFee').attr('notification-type-id', data[i].id);
                }
            }
            self.setState(newState);
        });
    }

    componentWillUpdate(nextProps, nextState) {

    }

    updateLateRentFee() {
        financial.updateLateRentFee(this.state, function(response) {
            modal.showInfo("Late Rent Fee was updated!", "success", "top", "center");
        });
    }

    switchTriggered(e) {}

    render(){
        const transferFee = this.state.transferFee;
        return (
            <div class="col-md-8">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-edit"></i> <small><i class="pe-7s-angle-right"></i></small> Transfer Fee</h4>
                        <p class="category">Add 1% to the total transaction when a tenant pays you.</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b></b></p>
                            </div>
                            <div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="effective_date">Transfer 1% Fee</label>
                                        <br/>
                                        <input type="checkbox" class="toggle-switch" id="transferFee" defaultChecked={transferFee} data-toggle="toggle" onChange={this.switchTriggered.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Settings/Financial/TransferFees.jsx